import { searchApi } from "src/assets/scripts/utilities/api-clients";

export const index = async (options = {}) => {
  const response = await searchApi.get("/global_search", options);

  return response;
};
